__turbopack_context__.v({
  "icon": "side-nav-menu-item-module-scss-module__gAzt1q__icon",
  "item": "side-nav-menu-item-module-scss-module__gAzt1q__item",
  "link": "side-nav-menu-item-module-scss-module__gAzt1q__link",
  "linkActive": "side-nav-menu-item-module-scss-module__gAzt1q__linkActive",
});
